export const CollapseIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M8.701 8.394V3.612l-2.397 2.39zm-7.365 2.275h2V1.336h-2zm3 0h6.333V1.336H4.336zm-4 1V.336h11.333v11.333z"
        ></path>
    </svg>
);

export const ExpandIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M6.309 8.39V3.622l2.39 2.382zm-4.973 2.28h2V1.335h-2zm3 0h6.333V1.335H4.336zm-4 1V.335h11.333v11.333z"
        ></path>
    </svg>
);

export const DashboardIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        fill="none"
        viewBox="0 0 20 16"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M13.096 15.5V9.096H19.5V15.5zm-4-8.596V.5H19.5v6.404zM.5 15.5V9.096h10.404V15.5zm0-8.596V.5h6.404v6.404z"
        ></path>
    </svg>
);

export const CompositionsIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        fill="none"
        viewBox="0 0 19 19"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="m4.447 0 4.447 2.628v5.255l-4.447 2.628L0 7.883V2.628zM14.15 0l4.447 2.628v5.255l-4.447 2.628-4.447-2.628V2.628zM9.298 8.492l4.447 2.628v5.255l-4.447 2.628-4.446-2.628V11.12z"
        ></path>
    </svg>
);

export const PermissionsIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        fill="none"
        viewBox="0 0 19 19"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M.5 15.498v-2.223q0-.735.399-1.36a2.66 2.66 0 0 1 1.067-.963 14.5 14.5 0 0 1 2.99-1.09A13 13 0 0 1 8 9.498a12 12 0 0 1 2.106.189 5 5 0 0 0 .52 2.42 5.15 5.15 0 0 0 1.599 1.891v1.5zm15.346 2.692-1.334-1.328v-4.118a3.04 3.04 0 0 1-1.596-1.1 3 3 0 0 1-.618-1.867q0-1.287.91-2.196a3 3 0 0 1 2.196-.91q1.286 0 2.191.91.905.911.905 2.197 0 .999-.56 1.768-.561.77-1.43 1.106l1.105 1.106-1.326 1.33 1.326 1.33zM8 7.883q-1.444 0-2.472-1.028T4.5 4.383 5.528 1.91 8 .883t2.472 1.028T11.5 4.383q0 1.443-1.028 2.472T8 7.883m7.404 2.336a.84.84 0 0 0 .626-.263.87.87 0 0 0 .258-.63.85.85 0 0 0-.258-.627.85.85 0 0 0-.626-.259.87.87 0 0 0-.631.26.85.85 0 0 0-.264.625.86.86 0 0 0 .264.63.86.86 0 0 0 .63.264"
        ></path>
    </svg>
);

export const PluginIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        fill="none"
        viewBox="0 0 19 19"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M5.877 18.497H.5V13.12a2.95 2.95 0 0 0 1.764-.854A2.4 2.4 0 0 0 3 10.496q0-1.04-.736-1.768A2.95 2.95 0 0 0 .5 7.874V2.497H6q.135-.954.835-1.573A2.43 2.43 0 0 1 8.5.304a2.43 2.43 0 0 1 1.665.62q.7.62.835 1.573h5.5v5.5q.954.135 1.573.835.62.702.62 1.665a2.43 2.43 0 0 1-.62 1.664 2.5 2.5 0 0 1-1.573.836v5.5h-5.377q-.135-1.077-.879-1.789-.744-.711-1.744-.711t-1.744.711q-.745.712-.879 1.789"
        ></path>
    </svg>
);

export const SettingsIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="m7.69 19.5-.38-3.046a5.334 5.334 0 0 1-1.579-.896L2.908 16.75l-2.307-4 2.44-1.844a5 5 0 0 1-.05-.448 7 7 0 0 1 0-.882q.015-.22.05-.482L.602 7.25l2.307-3.98 2.812 1.182a6.4 6.4 0 0 1 .772-.524 5 5 0 0 1 .807-.382L7.69.5h4.615l.381 3.056q.45.164.814.381.365.22.736.515l2.85-1.183 2.308 3.981-2.48 1.873q.055.243.06.453t.004.424q0 .204-.01.415-.01.21-.068.481l2.46 1.854-2.309 4-2.815-1.202q-.37.296-.758.524a4.6 4.6 0 0 1-.792.372l-.38 3.056zm2.32-6.5q1.247 0 2.123-.876A2.9 2.9 0 0 0 13.01 10q0-1.248-.876-2.124A2.9 2.9 0 0 0 10.01 7q-1.263 0-2.132.876A2.9 2.9 0 0 0 7.01 10q0 1.248.868 2.124.87.876 2.132.876"
        ></path>
    </svg>
);

export const LogoutIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
    >
        <path
            fill="#fff"
            d="M.336 11.67V.335h5.673v1H1.336v9.333h4.673v1zm8.487-2.821-.692-.723 1.623-1.623H4.067v-1h5.687L8.13 3.88l.692-.724 2.846 2.847z"
        ></path>
    </svg>
);

export const AccountIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="16"
        fill="none"
        viewBox="0 0 13 16"
    >
        <path
            fill="#696969"
            d="M12.115 15.901h-1.514v-1.514a2.27 2.27 0 0 0-2.272-2.272H3.786a2.27 2.27 0 0 0-2.272 2.272V15.9H0v-1.514A3.786 3.786 0 0 1 3.786 10.6h4.543a3.786 3.786 0 0 1 3.786 3.786zM6.058 9.086a4.543 4.543 0 1 1 0-9.086 4.543 4.543 0 0 1 0 9.086m0-1.514a3.029 3.029 0 1 0 0-6.058 3.029 3.029 0 0 0 0 6.058"
        ></path>
    </svg>
);

export const MenuIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="17"
        fill="none"
        viewBox="0 0 19 17"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M13.234 14.67v2h-11v-2zm5-7v2h-18v-2zm-2-7v2h-11v-2z"
        ></path>
    </svg>
);